export enum ResponseCode {
  SUCCESS = '1',
  ERROR = '0', // 服务器异常
  ILLEGAL_REFERENCE = '101',
  UNREGISTERED = '20000',
  AUTH_FAILED = '401',
  NO_LOGIN = '111006',
  BLACK_LOGIN = '111008',
  RESTART_LOGIN = '200016',
  TOKEN_NULL = '20001',
  ILLEGA_PARAMETER = '20002',
  DUPLICATED_USER = '20003',
  USER_DONT_EXIST = '20004',
  CLASS_NAME_ALREADY_EXIST = '20005',
  CLASS_NOT_EXIST = '20006',
  COURSE_DONT_EXIST = '20007',
  ERROR_CODE = '20008',
  WORKS_DONT_EXIST = '20009',
  NOT_HEADMASTER = '20010',
  NOT_MASTER = '20011',
  UP_FAILURE = '20012',
  PHONE_ALREADY_BIND = '20013',
  USER_ALREADY_SIGNED = '200014',
  NO_CODE_SCANNING = '200015',
  NUMBER_999 = '999'
}

/* 英富曼展会 */
// 5014,5743,7923,7924,7925,9816
// 369,2898,3991,3991,8588
export const blackList = [
  // 8588,
  // 8541, 3106, 3176, 3295, 6336, 1454, 3277, 3372, 6790, 6865, 7152, 6866, 6466, 3370, 8542, 9284,
  // 9283, 7121, 3770, 3769, 439, 7364, 3201, 3200,
  // // 5743,
  // // 7923,
  // // 7924,
  // // 7925,
  // 3907, 7304, 7305, 6275, 6805, 3256, 3317, 7508, 3026, 981, 483,
  // // 3991,
  // 866, 8543, 3247,
  // // 2898,
  // 3344, 8373, 3066, 3906, 8374, 3811, 3812, 3813, 4059, 6817
]


/**
 * 配置工具函数
 */

// 获取百度地图 API 密钥
export const getMapKey = () => {
  // 根据环境返回不同的密钥
  let list = [
      'mWVmPlkNZpXdbuv2S3bZ5m4EgvEiCDmM',
      'UuvUtkoOfmYzpFDYKIEdxjAjq1wVhCwn',
      'Tkeq6mOp9VV5N5tIftgO4w7gZusB85ub',
      'tUqfKHImfHjhHbrwITikyLjRNqVzRnkC',
      'kkp9JpB03B2oFS48zIcnkMUxXKWJODyT',
  ];
  const randomIndex = Math.floor(Math.random() * list.length);
  return list[randomIndex];
}

// 获取高德地图密钥
export const getGaodeKey = () => {
  return '8607adb51cc446875a7a4da2f229da22'
}

/**
 * trace
 * @author wwl
 * @created 2023/10/17
 * @modified 2023/10/17
 */
export enum TraceCode {
  SUCCESS = 1,
  FAIL = 2,
  // 单据付费类型
  PAY = 1, // 付费
  FREE = 2, // 免费
  // 模块
  MO_COMMON = 'MO_COMMON',
  MO_HOME = 'MO_HOME', // 首页
  MO_NEWS = 'MO_NEWS', // 资讯
  MO_PAVILION = 'MO_PAVILION', // 会展中心
  MO_FAIR = 'MO_FAIR', // 展会
  MO_FAIR_BOOTH = 'MO_FAIR_BOOTH', // 展位
  MO_FAIR_PERIODICAL = 'MO_FAIR_PERIODICAL', // 期刊
  MO_FAIR_TICKET = 'MO_FAIR_TICKET', // 门票
  MO_HOTEL = 'MO_HOTEL', // 酒店
  MO_VISA = 'MO_VISA', // 签证
  MO_AIR_TICKET = 'MO_AIR_TICKET', // 机票
  // 业务 Code
  CC_FAIR_LIST = 'CC_FAIR_LIST', // 展会列表
  CC_FAIR_DETAIL = 'CC_FAIR_DETAIL', // 展会详情

  CC_FAIR_TICKET = 'CC_FAIR_TICKET', // 会展门票下单
  CC_TICKET_IN = 'CC_TICKET_IN', // 跳转站内门票预订
  CC_TICKET_OUT = 'CC_TICKET_OUT', // 跳转站外门票预订
  CC_SUBMIT_TICKET = 'CC_SUBMIT_TICKET', // 门票-提交订单
  CC_TO_ALIPAY_TICKET = 'CC_TO_ALIPAY_TICKET', // 门票-去支付(支付宝)
  CC_TO_WXPAY_TICKET = 'CC_TO_WXPAY_TICKET', // 门票-去支付(微信)
  CC_FAIR_PAY_SUCCESS = 'CC_FAIR_PAY_SUCCESS', // 支付成功

  CC_SUBMIT_BOOTH = 'CC_SUBMIT_BOOTH', // 展位-立即提交
  CC_APPLY_BOOTH = 'CC_APPLY_BOOTH', // 展位-展位咨询

  CC_APPLY_PERIODICAL = 'CC_APPLY_PERIODICAL', // 展商名录获取
  CC_SUBMIT_PERIODICAL = 'CC_SUBMIT_PERIODICAL', // 期刊-下一步，去支付
  CC_TO_ALIPAY_PERIODICAL = 'CC_TO_ALIPAY_PERIODICAL', // 期刊-去支付(支付宝)
  CC_TO_WXPAY_PERIODICAL = 'CC_TO_WXPAY_PERIODICAL', // 期刊-去支付(微信)
  CC_PERIODICAL_PAY_SUCCESS = 'CC_PERIODICAL_PAY_SUCCESS', // 支付成功

  CC_NEWS_LIST = 'CC_NEWS_LIST', // 资讯列表
  CC_NEWS_DETAIL = 'CC_NEWS_DETAIL', // 资讯详情

  CC_PAVILION_LIST = 'CC_PAVILION_LIST', // 会展中心列表
  CC_PAVILION_DETAIL = 'CC_PAVILION_DETAIL' // 会展中心详情
}
